/* OUGIST — language choice recorder.
   The ES auto-redirect itself runs inline in layout/theme.liquid (<head>) so it
   fires before first paint; this file only persists the visitor's EXPLICIT
   switcher choice so the inline script respects it on later visits. */
(function () {
  'use strict';

  var choiceKey = 'ougist-language-choice';

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-language-code]');
    if (button && event.isTrusted) {
      try { window.localStorage.setItem(choiceKey, button.getAttribute('data-language-code')); } catch (error) { /* storage is optional */ }
    }
  });
}());
